import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-b2e46b84"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "myperConfirm"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "perConfirm-title"
}, "修改个人资料", -1));
const _hoisted_3 = {
  class: "perConfirm-body"
};
const _hoisted_4 = {
  class: "login-container2"
};
const _hoisted_5 = {
  class: "loginall-body2"
};
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "loginall-text2"
}, [/*#__PURE__*/_createElementVNode("div", {
  style: {
    "margin-left": "-30px",
    "padding-top": "12px"
  }
}, " 已认证成功 ")], -1));
import { ref, reactive, onMounted, onDeactivated } from 'vue';
import { MessagePlugin } from 'tdesign-vue-next';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import { REG_TYPES } from '@/utils/index';
import { editDeveloper, getAuthCode, getDeveloper } from '@/http/api';
export default {
  __name: 'PersonalEdits',
  setup(__props) {
    const $router = useRouter();
    const form = ref(null);
    const formData = reactive({
      developerName: '',
      IDCardNum: '',
      phoneNum: '',
      verifyNum: '',
      email: '',
      address: '',
      confirmReal: 'true'
    });
    const isVerify = ref(false);
    const codeTimeFlag = ref(false);
    const userStr = localStorage.getItem('user');
    let tempUser = {};
    if (userStr) {
      tempUser = JSON.parse(userStr);
    }
    const identityType = tempUser.identityType;
    const confirmed = tempUser.confirmed;
    onMounted(async () => {
      const res = await getDeveloper();
      if (res && res.result) {
        const temp = res.data;
        formData.address = temp.user_address;
        formData.email = temp.user_email;
        formData.phoneNum = temp.user_phone;
        formData.developerName = temp.linkman;
        formData.IDCardNum = temp.identity_code;
      }
    });
    const getCode = async () => {
      const mobile = formData.phoneNum;
      if (!mobile) {
        MessagePlugin.warning('请填写手机号再获取验证码！');
        return;
      }
      const paramData = {
        mobile
      };
      const res = await getAuthCode(paramData);
      if (res.result && res.forwardData === 0) {
        MessagePlugin.success('获取手机验证码成功！');
      } else {
        MessagePlugin.error('获取手机验证码失败！');
      }
      codeTimeFlag.value = true;
      setTimeout(() => {
        codeTimeFlag.value = false;
      }, 1000 * 60);
    };
    const checkCode = async () => {
      const mobile = formData.phoneNum;
      const code = formData.verifyNum;
      if (mobile && code) {
        const paramData = {
          mobile,
          code
        };
        const res = await getAuthCode(paramData);
        if (res.result && res.forwardData === 0) {
          MessagePlugin.success('短信验证通过！');
          isVerify.value = true;
        } else {
          MessagePlugin.error('短信验证失败！');
        }
      }
    };
    const rules = {
      developerName: [{
        required: true,
        message: '姓名不能为空',
        type: 'error',
        trigger: 'blur'
      }, {
        pattern: REG_TYPES.limits.pattern,
        message: REG_TYPES.limits.message,
        trigger: 'blur'
      }],
      IDCardNum: [{
        required: true,
        message: '身份证号码不能为空',
        type: 'error',
        trigger: 'blur'
      }, {
        pattern: REG_TYPES.idCard.pattern,
        message: REG_TYPES.idCard.message,
        trigger: 'blur'
      }],
      phoneNum: [{
        required: true,
        message: '手机号码不能为空',
        type: 'error',
        trigger: 'blur'
      }, {
        pattern: REG_TYPES.mobile.pattern,
        message: REG_TYPES.mobile.message,
        trigger: 'blur'
      }],
      email: [{
        required: true,
        message: '邮箱不能为空',
        type: 'error',
        trigger: 'blur'
      }, {
        pattern: REG_TYPES.email.pattern,
        message: REG_TYPES.email.message,
        trigger: 'blur'
      }],
      address: [{
        required: true,
        message: '联系地址不能为空',
        type: 'error',
        trigger: 'blur'
      }],
      confirmReal: [{
        required: true,
        message: '请用已实名的QQ扫码认证填写的个人信息真实性',
        type: 'error',
        // trigger: 'all'
        trigger: 'change'
      }]
    };
    const onSubmit = async ({
      validateResult,
      firstError,
      e
    }) => {
      e.preventDefault();
      // 水滴 个人资料填写页提交按钮
      window._sdi.stat({
        ptype: '9',
        stype: '5'
      });
      if (confirmed == 1) {
        MessagePlugin.warning('您的资料正在审核中!');
        return;
      }
      if (validateResult === true) {
        if (!isVerify.value) {
          MessagePlugin.warning('请使用手机短信验证通过后再提交！');
          return;
        }
        const paramData = {
          identity_type: identityType,
          confirmed,
          user_phone: formData.phoneNum,
          user_email: formData.email,
          user_address: formData.address
        };
        const res = await editDeveloper(paramData);
        if (res.effect && res.result) {
          MessagePlugin.success('资料编辑成功！');
          tempUser.confirmed = 1;
          localStorage.setItem('user', JSON.stringify(tempUser));
          $router.push({
            path: '/softwarelibrary'
          });
        } else {
          MessagePlugin.error('资料编辑失败！');
        }
      } else {
        console.log('Validate Errors: ', firstError, validateResult);
        MessagePlugin.warning(firstError);
      }
    };
    return (_ctx, _cache) => {
      const _component_t_input = _resolveComponent("t-input");
      const _component_t_form_item = _resolveComponent("t-form-item");
      const _component_t_icon = _resolveComponent("t-icon");
      const _component_t_link = _resolveComponent("t-link");
      const _component_t_button = _resolveComponent("t-button");
      const _component_t_space = _resolveComponent("t-space");
      const _component_t_form = _resolveComponent("t-form");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _createElementVNode("div", _hoisted_3, [_createVNode(_component_t_form, {
        ref_key: "form",
        ref: form,
        data: formData,
        rules: rules,
        onSubmit: onSubmit
      }, {
        default: _withCtx(() => [_createVNode(_component_t_form_item, {
          style: 'padding-top: 55px',
          label: "姓名",
          name: "developerName",
          labelAlign: "left"
        }, {
          default: _withCtx(() => [_createVNode(_component_t_input, {
            modelValue: formData.developerName,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => formData.developerName = $event),
            disabled: "",
            placeholder: "请输入姓名"
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_t_form_item, {
          style: 'padding-top: 35px',
          label: "身份证",
          name: "IDCardNum",
          labelAlign: "left"
        }, {
          default: _withCtx(() => [_createVNode(_component_t_input, {
            modelValue: formData.IDCardNum,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => formData.IDCardNum = $event),
            placeholder: "请输入有效身份证号",
            disabled: ""
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_t_form_item, {
          style: {
            "padding-top": "35px"
          },
          label: "实名认证",
          name: "confirmReal",
          labelAlign: "left"
        }, {
          default: _withCtx(() => [_createVNode(_component_t_input, {
            style: {
              "display": "none"
            },
            modelValue: formData.confirmReal,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => formData.confirmReal = $event),
            placeholder: ""
          }, null, 8, ["modelValue"]), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createVNode(_component_t_icon, {
            name: "check-circle-filled",
            style: {
              "height": "42px",
              "width": "42px",
              "color": "#00be63"
            }
          })]), _hoisted_6])]),
          _: 1
        }), _createVNode(_component_t_form_item, {
          style: 'padding-top: 35px',
          label: "联系电话",
          name: "phoneNum",
          labelAlign: "left"
        }, {
          default: _withCtx(() => [_createVNode(_component_t_input, {
            disabled: isVerify.value,
            modelValue: formData.phoneNum,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => formData.phoneNum = $event),
            placeholder: "请输入手机号",
            maxlength: "11"
          }, null, 8, ["disabled", "modelValue"]), _createVNode(_component_t_link, {
            disabled: isVerify.value || codeTimeFlag.value,
            theme: "primary",
            hover: "color",
            onClick: _cache[4] || (_cache[4] = $event => getCode()),
            style: {
              "position": "absolute",
              "right": "15px",
              "z-index": "9"
            }
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(codeTimeFlag.value ? '重新发送' : '获取验证码'), 1)]),
            _: 1
          }, 8, ["disabled"])]),
          _: 1
        }), _createVNode(_component_t_form_item, {
          style: 'padding-top: 35px',
          label: "",
          labelAlign: "left"
        }, {
          default: _withCtx(() => [_createVNode(_component_t_input, {
            disabled: isVerify.value,
            modelValue: formData.verifyNum,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => formData.verifyNum = $event),
            placeholder: "请输入手机验证码",
            maxlength: "10"
          }, null, 8, ["disabled", "modelValue"]), _createVNode(_component_t_link, {
            disabled: isVerify.value,
            onClick: _cache[6] || (_cache[6] = $event => checkCode()),
            theme: "primary",
            hover: "color",
            style: {
              "position": "absolute",
              "right": "15px",
              "z-index": "9"
            }
          }, {
            default: _withCtx(() => [_createTextVNode(" 确认验证 ")]),
            _: 1
          }, 8, ["disabled"])]),
          _: 1
        }), _createVNode(_component_t_form_item, {
          style: 'padding-top: 35px',
          label: "联系邮箱",
          name: "email",
          labelAlign: "left"
        }, {
          default: _withCtx(() => [_createVNode(_component_t_input, {
            modelValue: formData.email,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => formData.email = $event),
            placeholder: "请输入日常使用的邮箱地址，方便我们联系您",
            maxlength: "56"
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_t_form_item, {
          style: 'padding-top: 35px',
          label: "联系地址",
          name: "address",
          labelAlign: "left"
        }, {
          default: _withCtx(() => [_createVNode(_component_t_input, {
            modelValue: formData.address,
            "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => formData.address = $event),
            placeholder: "示例：深圳市南山区深南大道xx号x号楼x单元xxx",
            maxlength: "48"
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_t_form_item, {
          style: 'padding-top: 40px'
        }, {
          default: _withCtx(() => [_createVNode(_component_t_space, {
            size: "small"
          }, {
            default: _withCtx(() => [_createVNode(_component_t_button, {
              style: 'width: 150px',
              theme: "primary",
              type: "submit"
            }, {
              default: _withCtx(() => [_createTextVNode("提交")]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }, 8, ["data"])])]);
    };
  }
};